// Deprecated.
// This file has been moved to `./libphonenumber` directory.
// This file is still here for legacy compatibility with some
// hypothetical application code that could theoretically import
// this file directly.

export {
	default as default,
	formatPhoneNumberIntl
} from './libphonenumber/formatPhoneNumber'